import { Table, TableBody, TableContainer, TableHead, TableRow } from '@mui/material'
import * as React from 'react'
import { StyledTableCell } from '../../../core/StyledTableCell'
import {
	ShiftEndTaskSummary,
	ShiftEndWorkItemsSummary,
} from '../../../../types/Reports/ShiftEnd/ShiftEndWorkItems'
import WorkerSummaryRow from './WorkerSummaryRow'
import { useState } from 'react'
import ConfirmDialog from '../../../core/ConfirmDialog'
import { useShiftEndContext } from '../ShiftEndContext'
import dayjs from 'dayjs'
import { revertTaskProgress } from '../../../../services/shiftEndReportService'
import { useParams } from 'react-router-dom'
import { useTokenClaims } from '../../../../security/useTokenClaims'

type workItemsProps = {
	workItemData: ShiftEndWorkItemsSummary[]
	loadData: () => void
}

const WorkerSummaryGrid = ({ workItemData, loadData }: workItemsProps): JSX.Element => {
	const [taskToRevert, setTaskToRevert] = useState<ShiftEndTaskSummary | null>(null)
	const [unitOfMeasure, setUnitOfMeasure] = useState<string | null>(null)
	const [overridingTask, setOverridingTask] = useState<number | null>(null)
	const { shiftDate } = useShiftEndContext()
	const params = useParams()
	const {role, id} = useTokenClaims()
	const foremanId = role?.title === 'Foreman' ? Number(id) : Number(params.id)
	const handleRevertTask = async () => {
		if (!taskToRevert) return
		setOverridingTask(taskToRevert.id)
		try {
			await revertTaskProgress(taskToRevert.id, shiftDate, foremanId)
			loadData()
		} finally {
			setOverridingTask(null)
			setTaskToRevert(null)
		}
	}
	return (
		<>
			<TableContainer
				sx={{
					height: 'calc(80vh - 56px)',
					width: '100%',
					overflowX: 'scroll',
					overflowY: 'scroll',
				}}
			>
				<Table stickyHeader>
					<TableHead>
						<TableRow>
							<StyledTableCell align='center'></StyledTableCell>
							<StyledTableCell align='center'>Type</StyledTableCell>
							<StyledTableCell align='left'>Title</StyledTableCell>
							<StyledTableCell align='center' sx={{ pl: 0 }}>
								Qty Budgeted
							</StyledTableCell>
							<StyledTableCell align='center' sx={{ pl: 0 }}>
								Qty Complete
							</StyledTableCell>
							<StyledTableCell align='center'>Actual Hours</StyledTableCell> {/* Burned Hours */}
							<StyledTableCell align='center'>PF</StyledTableCell>
							<StyledTableCell align='center'>% Complete</StyledTableCell>
							<StyledTableCell align='center'>Budgeted Hours</StyledTableCell>
							<StyledTableCell align='center'>Action</StyledTableCell>
							<StyledTableCell align='center'>Status</StyledTableCell>
						</TableRow>
					</TableHead>

					<TableBody>
						{(workItemData ?? []).map((workItem: ShiftEndWorkItemsSummary, index: number) => (
							<WorkerSummaryRow
								key={index}
								workItem={workItem}
								loadData={loadData}
								setTaskToRevert={setTaskToRevert}
								overridingTask={overridingTask}
								setUnitOfMeasure={setUnitOfMeasure}
							/>
						))}
						{(workItemData?.length ?? 0) === 0 && (
							<TableRow>
								<StyledTableCell align='center' scope='row' colSpan={17}>
									<h4 style={{ fontStyle: 'italic' }}>
										No Time Sheets were found for this Foreman
									</h4>
								</StyledTableCell>
							</TableRow>
						)}
					</TableBody>
				</Table>
			</TableContainer>
			<ConfirmDialog
				title='Revert Progress'
				visible={!!taskToRevert}
				onConfirm={handleRevertTask}
				onCancel={() => setTaskToRevert(null)}
				confirmButtonText={overridingTask ? 'Reverting...' : 'Revert'}
				canConfirm={!overridingTask}
				cancelButtonText='Cancel'
			>
				<div>
					<p>
						On {dayjs(shiftDate).format('MM/DD/YYYY')}, foreman progressed this task by{' '}
						{taskToRevert?.dayProgress} {unitOfMeasure}.
					</p>
					<p>By reverting, this progress will be removed from the task.</p>
					<p>Are you sure you want to proceed?</p>
				</div>
			</ConfirmDialog>
		</>
	)
}

export default WorkerSummaryGrid
